import * as React from "react";
import type { VersionSummary } from "../../agreement";
import { VersionRowActions } from "./VersionRowActions";
import {
  formatVersionDateLocale,
  lineageLabel,
  revisionRowLabel,
} from "./versionHistoryUtils";

export type VersionRevisionRowProps = {
  version: VersionSummary;
  isCurrent: boolean;
  promoting?: boolean;
  onPromote?: () => void;
};

export const VersionRevisionRow: React.FC<VersionRevisionRowProps> = ({
  version,
  isCurrent,
  promoting,
  onPromote,
}) => {
  const label = revisionRowLabel(version);
  const lineage = lineageLabel(version);
  const statusNote = version.is_promoted
    ? "Promoted"
    : version.is_superseded
      ? "Superseded"
      : null;

  return (
    <div className="versions-row versions-row--revision">
      <span
        className={`versions-rev-dot${isCurrent ? " is-current" : ""}`}
        aria-hidden
      />
      <span className="versions-row__rev-label">{label}</span>
      {isCurrent ? <span className="versions-current-badge">Current</span> : null}
      {statusNote ? <span className="versions-row__status-note">{statusNote}</span> : null}
      <span className="versions-row__date">{formatVersionDateLocale(version.created_at)}</span>
      {lineage ? <span className="versions-row__lineage">{lineage}</span> : null}
      <VersionRowActions
        label={label}
        version={version}
        compact
        promoting={promoting}
        onPromote={onPromote}
      />
    </div>
  );
};
